module.exports = __webpack_public_path__ + "static/media/header-item-building.f1619efa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/header-item-building.svg
// module id = 1554
// module chunks = 0